import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import styles from './ACDropDown.module.scss';

export default class ACDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getSingleSelectDropDown(style) {
    const icon = this.props.icon ? this.props.icon : ArrowDropDownIcon;
    let { selected, text } = this.props;

    let value = selected ? selected : text;

    return (
      <FormControl className={styles.editableOption}>
        <Select
          value={value}
          name="option"
          style={style}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          }}
          onChange={this.props.onChangeFunc}
          key={this.props.key}
          IconComponent={icon}
        >
          {this.props.options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              <ListItemText primary={opt} className={styles.capitalized} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  getMultipleSelectDropDown(style) {
    const icon = this.props.icon ? this.props.icon : ArrowDropDownIcon;
    let selected = [...this.props.selected];
    let text = this.props.text;
    const index = selected.indexOf(text);

    if (index > -1) selected.splice(index, 1);
    let value = [];
    if (this.props.showSelected === false) {
      value = [];
    } else {
      value = selected.length > 0 ? [...selected] : [text];
    }

    return (
      <FormControl className={styles.editableOption}>
        <Select
          multiple
          value={value}
          onChange={this.props.onChangeFunc}
          input={<Input id="select-multiple-checkbox" />}
          style={style}
          renderValue={(selected) => {
            return selected.join(', ');
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          IconComponent={icon}
        >
          {
            <MenuItem key={text} disabled value="">
              <ListItemText primary={text} className={styles.capitalized} />
            </MenuItem>
          }
          {this.props.options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              <Checkbox checked={selected.includes(opt)} color="primary" />
              <ListItemText primary={opt} className={styles.capitalized} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  renderDropDown(isMultiple, style) {
    if (isMultiple) {
      return this.getMultipleSelectDropDown(style);
    } else {
      return this.getSingleSelectDropDown(style);
    }
  }

  render() {
    const backgroundColor = this.props.backgroundColor || 'white';
    const isMultiple = this.props.isMultiple || false;
    const color = this.props.color || 'white';
    const s = {
      backgroundColor: backgroundColor,
      borderRadius: '18px',
      fontSize: '12px',
      boxShadow: '0 0',
      textTransform: 'capitalize',
      color: color,
      borderColor: 'rgba(255, 255, 255, 0.3)'
    };

    return this.renderDropDown(isMultiple, s);
  }
}
